import React, { useContext, useState } from "react";
import { observer } from "mobx-react-lite";
import { Button, Card, Col, Row } from "reactstrap";
import classNames from "classnames";
import { RootStoreContext } from "../../app/stores/rootStore";
import Loader from "../common/Loader";
import moment from "moment";
import Rate from "rc-rate";
import surveyQuestionType, {
  SurveyDetailsPlayerDto,
  SurveyPlayerDto,
  Votes,
} from "../../app/models/survey";
import classnames from "classnames";
import { useTranslation } from "react-i18next";
import { translationHookOptions } from "../../app/localization/localization";

export interface SurveyParams {
  meetingId: number;
}

const SurveyVote: React.FC<SurveyParams> = ({ meetingId }) => {
  const rootStore = useContext(RootStoreContext);
  const { theme } = rootStore.commonStore;
  const {
    surveyId,
    addAnswers,
    addFreeAnswer,
    addAnswerVote,
    surveyAnswersDetail,
  } = rootStore.surveyStore;

  const [answers, setAnswers] = useState<{
    surveyId: number;
    surveyResponsesId: number[];
  } | null>(null);
  const [answersStars, setAnswersStars] = useState<Votes | null>({ votes: [] });
  const [selectedButtonIds, setSelectedButtonIds] = useState<number[]>([]);
  const [freeSurveyInput, setFreeSurveyInput] = useState("");
  const [isAnswersStarsFull, setIsAnswersStarsFull] = useState(false);
  const { setView, setSurveyId, surveyResultDetails } = rootStore.surveyStore;
  const [t] = useTranslation(
    ["translation", "surveys"],
    translationHookOptions
  );

  let vote: number = 0;
  let isStarsDisabled: boolean = false;
  const getRowVote = (responseId: number) => {
    if (surveyAnswersDetail) {
      surveyAnswersDetail.answersVote.map(function (answerVote) {
        if (answerVote.responseId === responseId) {
          vote = answerVote.vote;
          isStarsDisabled = true;
        }
        return vote;
      });
      return vote;
    }
  };

  const isToDisableButton = () => {
    if (answers && answers.surveyResponsesId.length > 0) return false;
    if (freeSurveyInput) return false;
    if (isAnswersStarsFull) return false;

    return true;
  };

  const handleSubmitClick = () => {
    if (surveyAnswersDetail && surveyAnswersDetail.survey) {
      const surveyType = surveyAnswersDetail.survey.surveyQuestionTypeId;
      switch (surveyType) {
        case surveyQuestionType.Single:
        case surveyQuestionType.Multiple:
          addAnswers(meetingId, surveyAnswersDetail.survey.surveyId, answers!);
          break;
        case surveyQuestionType.Free:
          addFreeAnswer(
            meetingId,
            surveyAnswersDetail.survey.surveyId,
            freeSurveyInput
          );
          break;
        case surveyQuestionType.Rating:
          if (answersStars) {
            addAnswerVote(meetingId, surveyId, answersStars);
          }
          break;
        default:
          break;
      }
    }
  };

  const selectResponse = (voteId: number, survey: SurveyPlayerDto) => {
    if (survey.surveyQuestionTypeId === surveyQuestionType.Single) {
      const surveyResponsesId: number[] = [voteId];
      setAnswers({ surveyId, surveyResponsesId });
      setSelectedButtonIds(surveyResponsesId);
    } else if (survey.surveyQuestionTypeId === surveyQuestionType.Multiple) {
      let currentResponsesId = answers ? answers.surveyResponsesId : [];
      if (currentResponsesId.includes(voteId)) {
        currentResponsesId = currentResponsesId.filter((x) => x !== voteId);
        setAnswers({
          surveyId: surveyId,
          surveyResponsesId: currentResponsesId,
        });
        setSelectedButtonIds(currentResponsesId);
      } else if (currentResponsesId.length < survey.maxNumberAnswer) {
        currentResponsesId.push(voteId);
        setAnswers({
          surveyId: surveyId,
          surveyResponsesId: currentResponsesId,
        });
        setSelectedButtonIds(currentResponsesId);
      }
    }
  };

  const setVoteStars = (responseId: number, vote: number) => {
    if (answersStars) {
      const index = answersStars.votes.findIndex(
        (answer) => answer.responseId === responseId
      );
      if (index > -1) {
        answersStars.votes.splice(index, 1);
      }
      const answerData = { responseId, vote };
      let tempAnswersStars = answersStars;
      tempAnswersStars.votes.push(answerData);
      setAnswersStars(tempAnswersStars);
      setIsAnswersStarsFull(true);
    }
  };

  const setTextValue = () => {
    if (surveyAnswersDetail && surveyAnswersDetail.answerFree !== "") {
      return surveyAnswersDetail.answerFree;
    }
  };

  const showSubmitButton = (details: SurveyDetailsPlayerDto) => {
    switch (details.survey.surveyQuestionTypeId) {
      case surveyQuestionType.Single:
      case surveyQuestionType.Multiple:
        console.log(details);
        return details.answers.length === 0;
      case surveyQuestionType.Free:
        console.log(details);
        return details.answerFree.length === 0;
      case surveyQuestionType.Rating:
        console.log(details);
        return details.answersVote.length === 0;
      default:
        break;
    }

    return false;
  };

  const goBack = () => {
    setView("list");
    setSurveyId(0);
  };

  if (!surveyAnswersDetail) return <Loader />;

  return (
    <div>
      <Row>
        <Col sm={3} xl={2} className="">
          <Button
            onClick={() => goBack()}
            className={classNames(
              "surveyButton backButton",
              `${theme!.buttonColor} ${theme!.buttonBorderColor} ${
                theme!.buttonTextColor
              }`
            )}
          >
            <span className="btn-inner--icon">
              <i className="fas fa-arrow-left" />
            </span>
            <span className="btn-inner--text"> {t("back")}</span>
          </Button>
        </Col>
        <Col sm="9" className="ml-auto">
          {showSubmitButton(surveyAnswersDetail) ? (
            <Button
              className={classNames(
                "surveyButton float-right pr-5 pl-5",
                `${theme!.buttonColor} ${theme!.buttonBorderColor} ${
                  theme!.buttonTextColor
                }`
              )}
              disabled={isToDisableButton()}
              onClick={() => handleSubmitClick()}
            >
              {t("save")}
            </Button>
          ) : (
            <h5 className="mt-2 float-right">
              {t("voted_on_text", { ns: "surveys" })}{" "}
              {t("voted_on_date", {
                ns: "surveys",
                val: moment(surveyAnswersDetail.answerDate).toDate(),
                formatParams: {
                  val: {
                    year: "numeric",
                    month: "long",
                    day: "numeric",
                    hour: "numeric",
                    minute: "numeric",
                    second: "numeric",
                  },
                },
              })}
            </h5>
          )}
        </Col>
      </Row>

      <Card className=" mt-4 voteCard">
        <Row className="justify-content-center mb-2 mt-2">
          <h4 className="surveyQuestion">
            {surveyAnswersDetail.survey.questionsLanguages.question}
          </h4>
        </Row>
      </Card>

      <Card className=" mt-4 voteCard">
        <div className="mt-2 mb-2">
          {/* RISPOSTA SINGOLA O MULTIPLA */}
          {surveyAnswersDetail.survey.surveyQuestionTypeId ===
            surveyQuestionType.Single ||
          surveyAnswersDetail.survey.surveyQuestionTypeId ===
            surveyQuestionType.Multiple ? (
            <div className="form-check">
              {surveyAnswersDetail.responses.map((answer) => (
                <div
                  className={classnames(
                    "col-12 mb-2 mt-2 custom-control text-center",
                    surveyAnswersDetail.survey.surveyQuestionTypeId ===
                      surveyQuestionType.Multiple
                      ? "custom-checkbox"
                      : "custom-radio"
                  )}
                >
                  <input
                    name="responses"
                    id={answer.responseId.toString()}
                    type={
                      surveyAnswersDetail.survey.surveyQuestionTypeId ===
                      surveyQuestionType.Multiple
                        ? "checkbox"
                        : "radio"
                    }
                    key={answer.responseId}
                    color="inherit"
                    onClick={() =>
                      surveyAnswersDetail.answers.length === 0 &&
                      selectResponse(
                        answer.responseId,
                        surveyAnswersDetail.survey
                      )
                    }
                    className={classNames(
                      " col-1 custom-input",
                      surveyAnswersDetail.answers.includes(answer.responseId) ||
                        selectedButtonIds.includes(answer.responseId)
                        ? "voteRadioSelected"
                        : "",
                      surveyAnswersDetail.answers.includes(answer.responseId)
                        ? "noHoverButton"
                        : ""
                    )}
                    disabled={surveyResultDetails?.permissions.hasVote}
                    checked={
                      surveyAnswersDetail.answers.includes(answer.responseId) ||
                      selectedButtonIds.includes(answer.responseId)
                    }
                  ></input>
                  <label
                    htmlFor={answer.responseId.toString()}
                    className={classNames(
                      "pb-2 radioButtonLabel col-11 custom-label ",
                      surveyAnswersDetail.answers.includes(answer.responseId) ||
                        selectedButtonIds.includes(answer.responseId)
                        ? "radioButtonLabelSelected"
                        : "",
                      surveyAnswersDetail.answers.includes(answer.responseId)
                        ? "radioButtonLabelSelected"
                        : ""
                    )}
                  >
                    <h4 className="mb-0 surveyText"> {answer.response}</h4>
                  </label>
                </div>
              ))}
            </div>
          ) : null}

          {/* RISPOSTA LIBERA */}
          {surveyAnswersDetail.survey.surveyQuestionTypeId ===
          surveyQuestionType.Free ? (
            <div>
              <Row className="justify-content-center">
                <Col xs={12} className="px-4">
                  <textarea
                    rows={3}
                    className="form-control textAreaVote"
                    placeholder="Risposta"
                    onChange={(e) => setFreeSurveyInput(e.target.value)}
                    disabled={surveyAnswersDetail.answerFree !== ""}
                    value={setTextValue()}
                  ></textarea>
                </Col>
              </Row>
            </div>
          ) : null}

          {/* RISPOSTA VALUTATIVA per esempio da 1 a 10 */}
          {surveyAnswersDetail.survey.surveyQuestionTypeId ===
          surveyQuestionType.Rating ? (
            <div className="mt-2">
              {surveyAnswersDetail.responses.map((sur) => (
                <div>
                  <Row className="mb-2">
                    <Col xs={6}>
                      {/* <textarea value={sur.response} className="w-100"></textarea> */}
                      <div className="responseStarText">{sur.response}</div>
                    </Col>
                    <Col xs={6}>
                      <Rate
                        style={{ fontSize: 30 }}
                        allowHalf={false}
                        defaultValue={getRowVote(sur.responseId)}
                        disabled={isStarsDisabled}
                        count={surveyAnswersDetail?.survey.voteTo}
                        onChange={(value) =>
                          setVoteStars(sur.responseId, value)
                        }
                      />
                    </Col>
                  </Row>
                </div>
              ))}
            </div>
          ) : null}
        </div>
      </Card>
    </div>
  );
};

export default observer(SurveyVote);
